<!-- Footer -->
<footer class="footer">
    <div class="containerFooter">
        <p class="textFooter">@ BURGER QUEEN | Desarrollado por: Consuelo Goche | Katy Huamani Tito </p>
        <p class="textFooter">2020 - Derechos Reservados</p>
    </div>
</footer>
